module.exports = __webpack_public_path__ + "static/media/4x6-203dpi.7f4e307e.png";